export default __webpack_public_path__ + "static/media/TF5-1.c546b4f1.jpg";